import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'apply',
    standalone: true,
})
export class ApplyPipe implements PipeTransform {
    transform(value: Record<string, (...args: any[]) => any> | ((...args: any[]) => any), arg1: any, ...args: any[]): any {
        if (typeof value === 'function') {
            return value(arg1, ...args);
        }
        if (value && typeof arg1 === 'string' && typeof value[arg1] === 'function') {
            return value[arg1](...args);
        }
        throw new Error('Invalid arguments passed to ApplyPipe');
    }
}
